/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/cc-0-and-2-million-views.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/cc-0-and-2-million-views.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/cc-0-and-2-million-views.mdx';

const metadata = {
  slug: "cc-0-and-2-million-views",
  title: "CC 0 and 2 Million Views",
  author: "Christian Battaglia",
  description: "A spontaneous photo at the Tate Modern in London became my most viral creation — 2 million views on Unsplash and counting. Here's the story of a solo travel day, a hostel basement DJ, and the snap that started it all.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/people-tate-modern.webp",
  date: "2017-02-24T00:00:00.000Z",
  
  readTime: "5 min read",
  tags: ["photography","Unsplash","Tate Modern","London","Creative Commons","travel","solo travel","eurotrip"],
};

export const Route = createFileRoute('/blog/posts/cc-0-and-2-million-views')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/cc-0-and-2-million-views',
    image: '/og/blog/cc-0-and-2-million-views.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
